import {Cloud} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import GdriveAccounts from './GdriveAccounts';

export const gdriveAccounts: FeatureObject = {
  type: 'settings',
  title: 'Google Drive accounts',
  description: 'Manage linked Google Drive accounts for image-to-image projects',
  IconComponent: Cloud,
  path: '/settings/gdrive-accounts',
  component: (_user) => <GdriveAccounts />,
  status: FeatureStatus.PROD,
};
